/* eslint-disable */
// 自身のログイン状態をチェックする
//* eslint-disable */
import axios from 'axios'

let youbi_list = [ "日", "月", "火", "水", "木", "金", "土" ]
const GlobalData = {
    $User_email: null,  // メールアドレス
    facility_id: null,      // 施設ID
    kencd: null,        // 県コード
    kengen: null,       // 権限
    facility_code: null,      // 施設コード,URLの施設コード
    $ID_Token: {headers: {"Authorization": ""}},    // 認証用IDトークン格納ヘッダー

    shakyo: null,// URLの社協英名・社協コード
    choson_code: null,// 市区町村コード（社協英名を使ってAPIから取得）

    /* 本番環境用 */
    $UserPoolId: 'ap-northeast-1_3OHgw3311',//ログインユーザープールID（cognito）
    $ClientId: '3gi6k740mjirrs9asa5qro381e',//ログインクライアントID（cognito）
    $IdentityPoolId: 'ap-northeast-1:7cccd05d-44bd-4c61-9e06-15cc02bc823c',
    $API_URL:'https://www.volukatsu-yell.jp/dev/',//APIのURL・テスト用
   // $API_URL:'https://www.volukatsu-yell.jp/prod/',//APIのURL・本番用
    $CODE_URL:'https://www.volukatsu-yell.jp/',//QRコードのURL 
    $CSV_bucket:'volukatu-file',//CSVファイル（アンケート・報告書回答）のアップロード先
    $Image_bucket:'volukatu-images',//画像のアップロード先 
    $Ninsho_mail:'@volukatsu-yell.jp',
    /* 本番環境用ここまで */

    /* キテル（開発）環境用 */
     /*
    $UserPoolId: 'ap-northeast-1_6hWWd14Fy',//ログインユーザープールID（cognito）
//    $ClientId: 'athmhjnaevim1oel849bvg145',//ログインクライアントID（cognito）
    $ClientId: '4sdlml7a8v25nc1ugjvpckk65q',//ログインクライアントID（cognito）
    $cognitoDomain:'ap-northeast-1.amazoncognito.com',// Cognitoドメイン
    $IdentityPoolId: 'ap-northeast-1:d026f009-3ac3-4eef-8b41-4da0d048f8de',
    $API_URL:'https://www.volukatsu-taiken.net/dev/',//APIのURL・テスト用
//    $API_URL:'https://d19ywb8a0wx267.cloudfront.net/dev/',//APIのURL・テスト用
//    $API_URL:'https://d19ywb8a0wx267.cloudfront.net/prod/',//APIのURL・本番用
    $CODE_URL:'https://www.volukatsu-taiken.net/',//QRコードのURL  
    $CSV_bucket:'taiken-program',//CSVファイル（テンプレート）のアップロード先
    $Image_bucket:'volukatsu-images',//画像や証明書のアップロード先
    $Ninsho_mail:'@kitel.co.jp', 
    // $CODE_URL:'https://d1ewnd11x82mw8.cloudfront.net',//QRコードのURL  
    */
    /* キテル（開発）環境用ここまで */

    $Address_ken_list:["都道府県",//都道府県名のリスト
        "北海道","青森県","岩手県","宮城県","秋田県","山形県","福島県",
        "茨城県","栃木県","群馬県","埼玉県","千葉県","東京都","神奈川県",
        "新潟県","富山県","石川県","福井県","山梨県","長野県","岐阜県",
        "静岡県","愛知県","三重県","滋賀県","京都府","大阪府","兵庫県",
        "奈良県","和歌山県","鳥取県","島根県","岡山県","広島県","山口県",
        "徳島県","香川県","愛媛県","高知県","福岡県","佐賀県","長崎県",
        "熊本県","大分県","宮崎県","鹿児島県","沖縄県"],

    $saitama_list : [ // 埼玉県内の市区町村コードと市区町村名
        ["11100","さいたま市"],
        ["11101","さいたま市西区"],
        ["11102","さいたま市北区"],
        ["11103","さいたま市大宮区"],
        ["11104","さいたま市見沼区"],
        ["11105","さいたま市中央区"],
        ["11106","さいたま市桜区"],
        ["11107","さいたま市浦和区"],
        ["11108","さいたま市南区"],
        ["11109","さいたま市緑区"],
        ["11110","さいたま市岩槻区"],
        ["11201","川越市"],
        ["11202","熊谷市"],
        ["11203","川口市"],
        ["11206","行田市"],
        ["11207","秩父市"],
        ["11208","所沢市"],
        ["11209","飯能市"],
        ["11210","加須市"],
        ["11211","本庄市"],
        ["11212","東松山市"],
        ["11214","春日部市"],
        ["11215","狭山市"],
        ["11216","羽生市"],
        ["11217","鴻巣市"],
        ["11218","深谷市"],
        ["11219","上尾市"],
        ["11221","草加市"],
        ["11222","越谷市"],
        ["11223","蕨市"],
        ["11224","戸田市"],
        ["11225","入間市"],
        ["11227","朝霞市"],
        ["11228","志木市"],
        ["11229","和光市"],
        ["11230","新座市"],
        ["11231","桶川市"],
        ["11232","久喜市"],
        ["11233","北本市"],
        ["11234","八潮市"],
        ["11235","富士見市"],
        ["11237","三郷市"],
        ["11238","蓮田市"],
        ["11239","坂戸市"],
        ["11240","幸手市"],
        ["11241","鶴ヶ島市"],
        ["11242","日高市"],
        ["11243","吉川市"],
        ["11245","ふじみ野市"],
        ["11246","白岡市"],
        ["11301","伊奈町"],
        ["11324","三芳町"],
        ["11326","毛呂山町"],
        ["11327","越生町"],
        ["11341","滑川町"],
        ["11342","嵐山町"],
        ["11343","小川町"],
        ["11346","川島町"],
        ["11347","吉見町"],
        ["11348","鳩山町"],
        ["11349","ときがわ町"],
        ["11361","横瀬町"],
        ["11362","皆野町"],
        ["11363","長瀞町"],
        ["11365","小鹿野町"],
        ["11369","東秩父村"],
        ["11381","美里町"],
        ["11383","神川町"],
        ["11385","上里町"],
        ["11408","寄居町"],
        ["11442","宮代町"],
        ["11464","杉戸町"],
        ["11465","松伏町"],
        ["00001","テスト１"],
        ["00002","テスト２"],
        ["00003","テスト３"],
        ["00004","テスト４"],
        ["00005","テスト５"],
        ["00006","テスト６"],
        ["00007","テスト７"],
        ["00008","テスト８"],
        ["00009","テスト９"],
        ["00010","テスト１０"],
        ["00011","テスト１１"]],

    $Kotsu_list:["",  //交通手段（個人・団体）のリスト（１：自家用車、２：バイク、３：自転車、４：電車／バス、５：徒歩）
                 "自家用車","バイク","自転車","電車／バス","徒歩"],

    $Shokugyo_kbn_list:["",  //職業区分（個人）のリスト（１：学生、２：勤労者、９：その他）
                 "学生","勤労者","","","","","","","その他"],

    $Hoken_plan_list:["",//ボランティア活動保険プラン（個人）のリスト（１：基本、２：天災・地震補償、３：特定感染症重点）
                 "基本","天災・地震補償","特定感染症重点"],

    $Dantai_syurui_list:["",//種類（団体）のリスト（１：社協、２：団体、３：管理団体）
                 "社協","団体","管理団体"],

    $Iraisha_syurui_list:["",//依頼者（ボランティア活動）のリスト（１：個人、２：団体）
                 "個人","団体"],
                      
    $Taisho_list:["",//対象者（ボランティア活動）のリスト（１：身体障碍者、２：知的障碍者、３：精神障碍者、４：高齢、５：徒歩、９：その他）
                    "身体障碍者","知的障碍者","精神障碍者","高齢","児童","","","","その他"],
                    
    // 祝日を取得するAPIを呼び出すためのシークレットキー
    $holiday_key : 'AIzaSyBAyiDQTDocEEfUKIH67I_dKh6LzzOg26k',

    // 通信エラー時メッセージ
    $axios_error : "通信エラーが発生しました。画面を再読み込みしてください。",
}

// 各コンポーネント内の<script>タグ内でグローバル変数を参照するための関数
const getUser_email = function() {// ログインユーザーのメールアドレス
    return GlobalData.$User_email
};

// URLを絶対パスで指定  ここの場所は、当JavaScriptが再ロードした時にしか動かないので、GlobalDataに値が入っていない時に実行されることがある。
const login_url = location.protocol+"//"+location.host+"/"+GlobalData.shakyo+"/"+GlobalData.facility_code+"/Shisetsu/MailLogin"

async function login_check (){
    try {
        const res = await axios.post("/dev/auth_me", {}, { withCredentials: true });
        const user = res.data; // ← axiosでは .data から取得
    //    alert("ユーザー情報:"+JSON.stringify(user));

        GlobalData.$User_email = user.email
        GlobalData.$profile = JSON.parse(user.attributes)
        const profile = GlobalData.$profile

        if(profile.kengen.toLowerCase()  == "admin" || profile.kengen.toLowerCase()  == "kanri" ||
           profile.kengen.toLowerCase()  == "master" || profile.kengen.toLowerCase()  == "shakyouser" ||
           profile.kengen.toLowerCase()  == "ippan"
         ){
            alert("このアカウントでは施設用画面にログインできません。\n施設用のアカウントをご利用ください。")    
            logout()
            return
        }

        if(profile.facility_code != GlobalData.facility_code){
            alert("違う施設のアカウントなのでログインできません。\nこの施設用のアカウントをご利用ください。")    
            logout()
            return
        }

        if(profile.facility_id) GlobalData.facility_id = profile.facility_id
        if(profile.ken_code) GlobalData.kencd = profile.ken_code
        GlobalData.kengen = 'shisetsu'
        if(profile.facility_code) GlobalData.facility_code = profile.facility_code
        console.log("施設ID取得："+GlobalData.facility_code)
    } catch (err) {
        console.log("施設情報取得失敗:"+JSON.stringify(err.response) || err);
        // location.href=login_url
        location.href=location.protocol+"//"+location.host+"/"+GlobalData.shakyo+"/"+GlobalData.facility_code+"/Shisetsu/MailLogin"
    }
}

let cognitoUser = {}

    //—- ログアウト —------------------------------------------
const logout = async () => {

    const redirectUrl = location.protocol+"//"+location.host+"/"+GlobalData.shakyo+"/"+GlobalData.facility_code+"/Shisetsu";
    try {
        await axios.post("/dev/logout_lambda", {}, { withCredentials: true });
        //alert("ログアウトしました。");
        GlobalData.$User_email = null
        GlobalData.facility_id = null
        GlobalData.kencd = null
        GlobalData.kengen = null
        GlobalData.facility_code = null
        window.location.href = redirectUrl;

    } catch (err) {
        console.error(err);
        alert("ログアウト失敗");
        window.location.href = redirectUrl;
    }
};
   //年月日の表示を整える
   let DateSetting = function(changedate){

    if(changedate != null){
        

        // 曜日配列
        const youbi_list = ["日","月","火","水","木","金","土"]
        
        let date = Date.parse(changedate);
        let set_date = new Date(date);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
        set_date = new Date(set_date);
        
        return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日（"+youbi_list[set_date.getDay()]+"）";
    }else{
        return
    }
 }
 //時間の表示を整える
 let TimeSetting = function(changetime){
  if(changetime != null){
      
      return changetime.slice( 0, 5 );
  }else{
      return ""
  }

 }
  //年月日＋時間の表示を整える
  let DateTimeSetting = function(changedate){
     let date = Date.parse(changedate);
     let set_date = new Date(date);
     set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     set_date = new Date(set_date);
     set_date.setHours(set_date.getHours());
 
     //return date;
     return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日("+youbi_list[set_date.getDay()]+") "+ ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
  }
 
  //年月日＋時間の表示を整える(EU時間)
  let EuDateSetting = function(changedate){

    let eudate = Date.parse(changedate);
     let eu_set_date = new Date(eudate);
     eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     eu_set_date = new Date(eu_set_date);
     eu_set_date.setHours(eu_set_date.getHours()-9);
 
     const set_month = eu_set_date.getMonth()+1
 
     // 日時から日と時をそれぞれ抜き出す
     let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
     let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);
 
     let return_date = new Date(day + " "+time)
     return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     return_date = new Date(return_date);
 
     return (return_date.getMonth()+1)+"月"+return_date.getDate()+"日("+youbi_list[return_date.getDay()]+")"
  }
  //年月日＋時間の表示を整える(EU時間)
  let EuDateTimeSetting = function(changedate){

    let eudate = Date.parse(changedate);
     let eu_set_date = new Date(eudate);
     eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     eu_set_date = new Date(eu_set_date);
     eu_set_date.setHours(eu_set_date.getHours()-9);
 
     const set_month = eu_set_date.getMonth()+1
 
     // 日時から日と時をそれぞれ抜き出す
     let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
     let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);
 
     let return_date = new Date(day + " "+time)
     return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     return_date = new Date(return_date);
 
     return (return_date.getMonth()+1)+"月"+return_date.getDate()+"日("+youbi_list[return_date.getDay()]+")"+ ('00'+return_date.getHours()).slice(-2)+":"+('00'+return_date.getMinutes()).slice(-2)
  }

  //〆切日を整える
  let ShimekiriSetting = function(changedate){
     let date = Date.parse(changedate);
     let set_date = new Date(date);
     set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
     set_date = new Date(set_date);
     set_date.setHours(set_date.getHours());
 
     //return date;
     return set_date
  }
 //〆切日を整える(EU時間)
 let EuShimekiriSetting = function(changedate){

    let eudate = Date.parse(changedate);
    let eu_set_date = new Date(eudate);
    eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    eu_set_date = new Date(eu_set_date);
    eu_set_date.setHours(eu_set_date.getHours()-9);
    
    const set_month = eu_set_date.getMonth()+1
    
    // 日時から日と時をそれぞれ抜き出す
    let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
    let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);

    let return_date = new Date(day + " "+time)
    return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    return_date = new Date(return_date);

    return return_date

}
const Search_timestamp = function(timestamp){// 各検索の「更新日時」の計算
   
    let eudate = Date.parse(timestamp);
    let eu_set_date = new Date(eudate);
    eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    eu_set_date = new Date(eu_set_date);
    eu_set_date.setHours(eu_set_date.getHours()-9);
    
    const set_month = eu_set_date.getMonth()+1
    
    // 日時から日と時をそれぞれ抜き出す
    let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
    let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);

    let return_date = new Date(day + " "+time)
    return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    return_date = new Date(return_date);
    return return_date.getFullYear()+"-"+('00'+(return_date.getMonth()+1)).slice(-2)+"-"+('00'+return_date.getDate()).slice(-2)+" "+('00'+return_date.getHours()).slice(-2)+":"+('00'+return_date.getMinutes()).slice(-2);

}

  // 曜日の順番を入れ替える
  let youbi_irekae = function(set_youbi){

    if(set_youbi != null){
        
        // 表示したい並び順
        const order = ["月", "火", "水", "木", "金", "土", "日", "祝"];

        // 上の並び順に合わせて、「、」区切りで並び替える
        const after = set_youbi
        .split("、")
        .sort((a, b) => order.indexOf(a) - order.indexOf(b))
        .join("、");

        console.log(set_youbi+"→"+after)
        
        return after
        /*
        set_youbi = set_youbi.replace(/､/g, '、')
        
        let set_array = set_youbi.split("、")

        const syuku_youbi_list = ["日","月","火","水","木","金","土","祝"]
        let disp_youbi_list = []

        let set_list = ""
        // 日・祝以外を取得
        for(let s = 0;s<set_array.length;s++){
            for(let l = 0;l<syuku_youbi_list.length;l++){
                if(set_array[s] == syuku_youbi_list[l]){
                    if(syuku_youbi_list[l] != "日" && syuku_youbi_list[l] != "祝" ){
                        disp_youbi_list[disp_youbi_list.length] = syuku_youbi_list[l]
                    }
                }
            }
        }
        // 日を取得
        for(let s = 0;s<set_array.length;s++){
            for(let l = 0;l<syuku_youbi_list.length;l++){
                if(set_array[s] == syuku_youbi_list[l]){
                    if(syuku_youbi_list[l] == "日" ){
                        disp_youbi_list[disp_youbi_list.length] = syuku_youbi_list[l]
                    }
                }
            }
        }
        // 祝を取得
        for(let s = 0;s<set_array.length;s++){
            for(let l = 0;l<syuku_youbi_list.length;l++){
                if(set_array[s] == syuku_youbi_list[l] || set_array[s] == "祝日"){
                    if( syuku_youbi_list[l] == "祝" ){
                        disp_youbi_list[disp_youbi_list.length] = syuku_youbi_list[l]
                    }
                }
            }
        }

        // 重複を削除
        disp_youbi_list = Array.from(new Set(disp_youbi_list));

        for(let d = 0;d<disp_youbi_list.length;d++){
            
            if(set_list != "") set_list += "、"
            set_list += disp_youbi_list[d]
        }

        return set_list*/
    }
  }

 // 開催日を整える
let Kaisai_setting = function(chengedate){

    let kaisai_date = Date.parse(chengedate);
    let set_kaisai_date = new Date(kaisai_date);
    set_kaisai_date = set_kaisai_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_kaisai_date = new Date(set_kaisai_date);
    console.log("set_kaisai_date:"+set_kaisai_date)
    return set_kaisai_date.getFullYear()+"-"+(set_kaisai_date.getMonth()+1)+"-"+set_kaisai_date.getDate()

}

// 一般ユーザーの追加
const set_habitat = (facility_id,kencd,kengen,facility_code) => {
    let attributeList = [
        {
            Name: 'profile',
            Value: '{"facility_id":'+facility_id+',"kencd":'+kencd+',"kengen":"'+kengen+',"facility_code":"'+facility_code+'"}'
        } 
    ]
    cognitoUser.updateAttributes(attributeList,
        function(err, result) {
            if (err) {
            //    console.log(err.message || JSON.stringify(err));
                return;
            }
          //  console.log("updateAttribute result:"+result)
            login_check()
    });
}
export { GlobalData, getUser_email, login_check, logout,DateSetting,DateTimeSetting,EuDateSetting,EuDateTimeSetting,ShimekiriSetting,EuShimekiriSetting,TimeSetting, Search_timestamp, set_habitat,youbi_irekae,Kaisai_setting }
